// MessageDetailLayoutSelector.jsx
import React from 'react';
import styled from 'styled-components';
import { useOutletContext, useParams } from 'react-router';
import PropTypes from 'prop-types';

import Loading from '../component/Loading.jsx';
import UniversalComponent from '../component/UniversalComponent.jsx';
import Redirect from '../container/Redirect.js';

export const MessageDetailLayoutSelector = ({
  isPublished = true,
  meId = null,
  senderId = null,
}) => {
  const outletContext = useOutletContext();
  const layoutType = outletContext?.layoutType;

  const { messageId } = useParams();

  if (!layoutType) {
    return (
      <LoadingWrapper>
        <Loading />
      </LoadingWrapper>
    );
  }

  const isAuthor = meId && meId === senderId;
  if (!isPublished && !isAuthor) {
    return <Redirect to="/" />;
  }

  switch (layoutType) {
    case 'story': {
      return (
        <UniversalComponent
          filename="Container_StoryMessage"
          messageId={messageId}
          importer={
            /* #__LOADABLE__ */ () => import('../container/StoryMessage.js')
          }
        />
      );
    }
    case 'flix': {
      return (
        <UniversalComponent
          filename="Container_FlixDetail"
          importer={
            /* #__LOADABLE__ */ () => import('../container/FlixDetail.js')
          }
          messageId={messageId}
          isPublished={isPublished}
        />
      );
    }
    case 'post':
    default: {
      return (
        <UniversalComponent
          filename="Container_PostDetail"
          importer={
            /* #__LOADABLE__ */ () => import('../container/PostDetail.js')
          }
          messageId={messageId}
          isPublished={isPublished}
        />
      );
    }
  }
};

MessageDetailLayoutSelector.propTypes = {
  meId: PropTypes.string,
  senderId: PropTypes.string,
  isPublished: PropTypes.bool,
};

const LoadingWrapper = styled.div`
  padding: 20px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default MessageDetailLayoutSelector;
